var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.846 7.012a1 1 0 0 0-.149.05c-.037.018-2.21 2.036-4.826 4.485-3.575 3.345-4.772 4.477-4.814 4.551-.05.087-.057.123-.057.278s.007.192.057.28c.117.21.33.333.579.335.306.003-.14.396 4.862-4.286L12 8.49l4.502 4.214c5.003 4.682 4.556 4.289 4.862 4.286a.66.66 0 0 0 .58-.335c.049-.088.056-.124.056-.28 0-.155-.007-.191-.057-.278-.042-.074-1.24-1.207-4.814-4.552-3.88-3.632-4.776-4.461-4.857-4.494a.85.85 0 0 0-.427-.04",
    clipRule: "evenodd"
  })));
};
export default SvgChevronUp;